import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * Load Google Maps API dynamically from environment
 */
function loadGoogleMapsApi(): Promise<void> {
  return new Promise((resolve, reject) => {
    // Check if already loaded
    if ((window as any).google?.maps) {
      resolve();
      return;
    }

    const apiKey = (environment as any).googleMapsApiKey;
    if (!apiKey) {
      console.warn('Google Maps API key not configured in environment');
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,marker`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => {
      console.error('Failed to load Google Maps API');
      resolve(); // Continue app bootstrap even if maps fail
    };
    document.head.appendChild(script);
  });
}

// Load Google Maps first, then bootstrap Angular
loadGoogleMapsApi().then(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
